import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";
import {ServiceSideCostPaymentContext} from "../../context/service_side_cost_payment";

const TABLE_HEAD = ["#", "کاربر", "مشاور", "گرایش", "عنوان", "توضیحات", "وضعیت", "مبلغ", "زمان", "عملیات"];

export function ServiceSideCostPaymentGrid() {

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const {
    serviceSideCostPayments,
    setServiceSideCostPayment,
    setOpen,
  } = useContext(ServiceSideCostPaymentContext);

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مشاور": "agent_name",
    "گرایش": "branch_name",
    "عنوان": "title",
    "توضیحات": "description",
    "وضعیت": "status",
    "مبلغ": "agent_share",
    "زمان": "updated_at",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مشاور": true,
    "گرایش": true,
    "عنوان": true,
    "توضیحات": true,
    "وضعیت": true,
    "مبلغ": true,
    "زمان": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {serviceSideCostPayments.map(
          ({
             id,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             branch_name,
             title,
             description,
             agent_share,
             status,
             updated_at,
           }, index) => {
            const isLast = index === serviceSideCostPayments.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {person_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {agent_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="ghost"
                      value={status === 'new' ? "پرداخت نشده" :
                        status === 'agent_payed' ? 'پرداخت مشاور' :
                          status === 'settled' ? 'تسویه' :
                            status === 'canceled' ? 'لغو' :
                              status}
                      color={status === 'agent_payed' ? "cyan" :
                        status === 'new' ? 'amber' :
                          status === 'person_payed' ? 'indigo' :
                            status === 'settled' ? 'green' :
                              status}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(agent_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {`${persianNumberFormat(updated_at.split(" ")[1])} ${persianNumberFormat(updated_at.split(" ")[0])}`}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setServiceSideCostPayment(serviceSideCostPayments[index]);
                      setOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}